<template>
  <li class="app-product-information-sheet">
    <img src="/files/lidl/images/new-icons/svg/file-pdf-outline.svg" width="20" height="20" alt="" class="mime_icon" />
    <slot name="txtBefore"></slot>
    <a :href="sheetLink">
      <span v-html="formattedPibName"></span>
      <span class="version" v-if="showVersion"> &nbsp;({{ sheet.version }}) </span>
    </a>
    <slot name="txtAfter"></slot>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

/**
 * Diese Komponete übernimmt die Darstellung eines einzelnen Informationsblattes als Downloadlink
 */
export default {
  props: {
    sheet: {
      type: Object,
      default: () => {}
    },
    productInformation: {
      type: Object,
      default: () => {}
    },
    showVersion: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['brand']),
    formattedPibName() {
      const text = this.productInformation.pibName || ''
      return text.replace(/\b(Lidl Connect)\b/i, '<span class="uppercase">Lidl</span> <span lang="en">Connect</span>')
    },
    sheetLink: function() {
      const baseUrl = this.$config.apiUrl || ''
      return `${baseUrl}/api/document/product-information-sheet/${this.brand}/${this.sheet.documentReference}.pdf`
    }
  },
  name: 'ProductInformationSheet'
}
</script>
